import React, { useState, useEffect } from "react";
import dashboardclasses from "../dashboard.module.css";
import { IoClose } from "react-icons/io5";
import { FileUploader } from "react-drag-drop-files";
import { BsCloudUpload } from "react-icons/bs";
import { useForm } from "react-hook-form";
import { Services } from "../../Services";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { ToastError } from "../../Components/utils/ToastMessage";
import { AiOutlineClose } from "react-icons/ai";
import swal from "sweetalert";
import { v4 as uuidv4 } from "uuid";
import {
    validateNegativeValues,
    validateEmptySpaces,
} from "../../Components/utils/validations";
function AddCategory(props) {
    const Navigate = useNavigate();
    const token = { Authorization: `token ${sessionStorage.getItem("token")}` };
    const {
        register,
        handleSubmit,
        reset,
        setValue,
        watch,
        formState: { errors },
    } = useForm();
    const [base64, setbase64] = useState("");
    const [banners, setBanners] = useState([]);
    const [bannerFiles, setBannerFiles] = useState([]);
    const [OfferBanners, setOfferBanners] = useState([]);
    const [OfferbannerFiles, setOfferBannerFiles] = useState([]);
    const [categories, setcategories] = useState([]);
    const watchFormData = watch();
    const getcategories = () => {
        Services.Get_all_Categories("GET", null, token)
            .then((res) => {
                if (res.Status === 1) {
                    setcategories(res.categories);
                    console.log(props.editable);
                    if (props.editable) {
                        reset({
                            status: props.editable.status,
                            priority: props.editable.priority,
                            categoryname: props.editable.categoryname,
                            subcategoryname: props.editable.subcategoryname,
                        });
                        if (props?.editable?.offerbannersURLs?.length > 0) {
                            let offerbannerimages = [];
                            for (
                                let i = 0;
                                i < props?.editable?.offerbannersURLs?.length;
                                i++
                            ) {
                                offerbannerimages = [
                                    ...offerbannerimages,
                                    {
                                        base64: `${props?.editable?.offerbannersURLs[i]}`,
                                        name: props?.editable?.offerbannersURLs[
                                            i
                                        ],
                                        id: uuidv4(),
                                    },
                                ];
                            }
                            setOfferBanners(offerbannerimages);
                        }

                        if (
                            props?.editable?.subcategoryimagesURLs?.length > 0
                        ) {
                            let subcategory = [];
                            for (
                                let i = 0;
                                i <
                                props?.editable?.subcategoryimagesURLs.length;
                                i++
                            ) {
                                subcategory = [
                                    ...subcategory,
                                    {
                                        base64: `${props?.editable?.subcategoryimagesURLs[i]}`,
                                        name: props?.editable
                                            ?.subcategoryimagesURLs[i],
                                        id: uuidv4(),
                                    },
                                ];
                            }
                            setBanners(subcategory);
                        }
                        setbase64(`${props.editable.imageURL}`);
                    }
                } else if (res.Status === 0) {
                    ToastError(res.Message);
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };
    useEffect(() => {
        getcategories();

        const close = (e) => {
            if (e.key == "Escape") {
                console.log("close");
                props.setmodal(false);
                props.setEditable(false);
            }
        };
        window.addEventListener("keydown", close);
        return () => window.removeEventListener("keydown", close);
    }, []);

    const CancelHandler = (e) => {
        e.stopPropagation();
        props.setmodal(false);
        props.setEditable(false);
    };

    const openhandler = (e) => {
        e.stopPropagation();
    };
    const handleChange = (file) => {
        if (file.type === "image/png" || file.type === "image/jpeg") {
            setValue("imagename", file);
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                setbase64(reader.result);
            };
            reader.onerror = function (error) {
                console.log("Error: ", error);
            };
        } else {
            alert("please upload image in PNG and JPEG format ");
        }
    };
    const handleChange1 = (files) => {
        console.log(files);
        if (banners.length + files.length > 5) {
            alert("more than 5 files upload is not allowed");
            return;
        }
        for (let i = 0; i < files.length; i++) {
            if (
                files[i].type === "image/png" ||
                files[i].type === "image/jpeg"
            ) {
                let id1 = uuidv4();
                setBannerFiles((prev) => [
                    ...prev,
                    { file: files[i], id: id1 },
                ]);
                let reader = new FileReader();
                reader.readAsDataURL(files[i]);
                reader.onload = function () {
                    setBanners((prev) => [
                        ...prev,
                        { base64: reader.result, id: id1 },
                    ]);
                };
                reader.onerror = function (error) {
                    console.log("Error: ", error);
                };
            } else {
                alert("please upload image in PNG and JPEG format ");
                break;
            }
        }
    };
    const handleChange2 = (files) => {
        console.log(files);
        if (OfferBanners.length + files.length > 5) {
            alert("more than 5 files upload is not allowed");
            return;
        }
        for (let i = 0; i < files.length; i++) {
            if (
                files[i].type === "image/png" ||
                files[i].type === "image/jpeg"
            ) {
                let id = uuidv4();
                setOfferBannerFiles((prev) => [
                    ...prev,
                    { file: files[i], id: id },
                ]);
                let reader = new FileReader();
                reader.readAsDataURL(files[i]);
                reader.onload = function () {
                    setOfferBanners((prev) => [
                        ...prev,
                        { base64: reader.result, id: id },
                    ]);
                };
                reader.onerror = function (error) {
                    console.log("Error: ", error);
                };
            } else {
                alert("please upload image in PNG and JPEG format ");
                break;
            }
        }
    };

    const fileuploadDesign = (
        <div className={dashboardclasses["add-item"]}>
            <BsCloudUpload className={dashboardclasses["upload-icon"]} />
            <h5>Drag Your Image here</h5>
            <p>(Only *.jpeg and *.png images will be accepted)</p>
        </div>
    );

    const onSubmit = (data) => {
        let formaata = new FormData();
        Object.keys(data).forEach((key) => {
            formaata.set(key, data[key]);
        });

        if (!props.editable) {
            if (bannerFiles?.length > 0) {
                for (let i = 0; i < bannerFiles.length; i++) {
                    formaata.append("subcategoryimages", bannerFiles[i].file);
                }
            } else {
                swal("banner images is required", "", "warning");
                return;
            }
            if (OfferbannerFiles?.length > 0) {
                for (let i = 0; i < OfferbannerFiles.length; i++) {
                    formaata.append("offerbanners", OfferbannerFiles[i].file);
                }
            } else {
                swal("Offer images are required", "", "warning");
                return;
            }
            if (!data.imagename) {
                swal("Category Icon is required", "", "warning");
                return;
            }

            fetch(
                `${process.env.REACT_APP_BASE_URL_NODE}/${Services.Add_Subcategory}`,
                {
                    method: "POST",
                    body: formaata,
                    Authorization: `token ${sessionStorage.getItem("token")}`,
                }
            )
                .then((response) => response.json())
                .then((res) => {
                    console.log(res);
                    if (res.Status === 1) {
                        Navigate(`/subcategories?page=1`);
                        props.tableload(true);
                        props.setpageCount(1);
                        props.setmodal(false);
                        props.getCategories();
                        toast.success(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    } else if (res.Status === 0) {
                        toast.error(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                })
                .catch((error) => {
                    props.tableload(false);
                    alert("something went wrong please try again");
                    console.log(error);
                });
        } else if (props.editable) {
            let oldvalues = props.editable;
            console.log(oldvalues);
            let updated_Values;
            if (oldvalues.categoryname != watchFormData.categoryname) {
                updated_Values = {
                    ...updated_Values,
                    categoryname: watchFormData.categoryname,
                };
            }
            if (oldvalues.subcategoryname != watchFormData.subcategoryname) {
                updated_Values = {
                    ...updated_Values,
                    subcategoryname: watchFormData.subcategoryname,
                };
            }
            if (oldvalues.priority != watchFormData.priority) {
                updated_Values = {
                    ...updated_Values,
                    priority: watchFormData.priority,
                };
            }
            if (oldvalues.status != watchFormData.status) {
                updated_Values = {
                    ...updated_Values,
                    status: watchFormData.status,
                };
            }
            if (data?.imagename) {
                updated_Values = {
                    ...updated_Values,
                    imagename: data.imagename,
                };
            }

            if (
                !updated_Values &&
                bannerFiles?.length == 0 &&
                OfferbannerFiles?.length == 0
            ) {
                swal("No changes to apply", "", "warning");
                return;
            }
            updated_Values = { ...updated_Values, _id: oldvalues._id };
            console.log(updated_Values);
            let updated = new FormData();
            Object.keys(updated_Values).forEach((key) => {
                updated.append(key, updated_Values[key]);
            });
            if (bannerFiles?.length > 0) {
                for (let i = 0; i < bannerFiles.length; i++) {
                    updated.append("subcategoryimages", bannerFiles[i].file);
                }
            }
            if (OfferbannerFiles?.length > 0) {
                for (let i = 0; i < OfferbannerFiles.length; i++) {
                    updated.append("offerbanners", OfferbannerFiles[i].file);
                }
            }
            fetch(
                `${process.env.REACT_APP_BASE_URL_NODE}/${Services.update_Subcategory}`,
                {
                    method: "POST",
                    body: updated,
                    Authorization: `token ${sessionStorage.getItem("token")}`,
                }
            )
                .then((response) => response.json())
                .then((res) => {
                    console.log(res);
                    if (res.Status === 1) {
                        Navigate(`/subcategories?page=1`);
                        props.tableload(true);
                        props.setpageCount(1);
                        props.setmodal(false);
                        props.getCategories();
                        props.setEditable(false);
                        toast.success(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    } else if (res.Status === 0) {
                        toast.error(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                })
                .catch((error) => {
                    props.tableload(false);
                    alert("something went wrong please try again");
                    console.log(error);
                });
        }
    };
    const deleteHandler = (e) => {
        let id = e.currentTarget.getAttribute("id");
        let btnType = e.currentTarget.getAttribute("btnType");
        let name = e.currentTarget.getAttribute("name");

        if (btnType == "subcategoryimages") {
            let updatedBanners = banners.filter((item) => item.id != id);
            let updatedBannerfiles = bannerFiles.filter(
                (item) => item.id != id
            );
            setBanners(updatedBanners);
            setBannerFiles(updatedBannerfiles);
        } else if (btnType == "offerbanners") {
            let updatedOfferBanners = OfferBanners.filter(
                (item) => item.id != id
            );
            let updatedOfferBannerfiles = OfferbannerFiles.filter(
                (item) => item.id != id
            );
            setOfferBannerFiles(updatedOfferBannerfiles);
            setOfferBanners(updatedOfferBanners);
        }
        if (props.editable && name) {
            let body = { _id: props?.editable?._id, key: btnType, image: name };
            Services.Delete_subcategory_image(
                "POST",
                JSON.stringify(body),
                token
            )
                .then((res) => {
                    if (res.Status === 1) {
                        toast.success(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    } else if (res.Status === 0) {
                        toast.error(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                        if (res.Message === "Token expired") {
                            Navigate("/");
                        }
                    }
                })
                .catch((err) => {
                    // alert(err);
                    alert("something went wrong please try again");
                    console.log(err);
                });
        }
    };
    return (
        <div className={dashboardclasses.modal} onClick={CancelHandler}>
            <div
                className={dashboardclasses["modal-content"]}
                onClick={openhandler}>
                <div className={dashboardclasses["modal-content-header"]}>
                    <div>
                        <h3>
                            {props.editable
                                ? "Update Subcategory"
                                : "Add Subcategory"}
                        </h3>
                        <p>
                            {props.editable
                                ? "Update Subcategory"
                                : "Add Subcategory"}{" "}
                            and necessary information from here
                        </p>
                    </div>
                    <button
                        className={dashboardclasses["close-btn"]}
                        onClick={CancelHandler}>
                        <IoClose size={22} color={"red"} />
                    </button>
                </div>
                <form
                    className={dashboardclasses["add-items"]}
                    onSubmit={handleSubmit(onSubmit)}>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryname">Category Name</label>
                        <div className={dashboardclasses["select"]}>
                            <select
                                disabled={props.editable}
                                defaultValue={""}
                                {...register("categoryname", {
                                    required: "category name is required",
                                })}>
                                <option value="" disabled>
                                    Select Category
                                </option>
                                {categories.map((item) => (
                                    <option value={item.categoryname}>
                                        {item.categoryname}
                                    </option>
                                ))}
                            </select>
                            {errors?.categoryname && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.categoryname?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryName">Subcategory Name</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                disabled={props.editable}
                                {...register("subcategoryname", {
                                    required: "Subcategory name is required",
                                    validate: validateEmptySpaces,
                                })}
                            />

                            {errors?.subcategoryname && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.subcategoryname?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="category">Category Icon</label>

                        <FileUploader
                            classes={dashboardclasses["upload-image"]}
                            multiple={false}
                            handleChange={handleChange}
                            name="file"
                            children={fileuploadDesign}
                            // types={fileTypes}
                        />
                    </div>
                    <div className={dashboardclasses["uploaded-img"]}>
                        <img src={base64} alt="" width={"120px"} />
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="category">Banner Images</label>

                        <FileUploader
                            classes={dashboardclasses["upload-image"]}
                            multiple={true}
                            handleChange={handleChange1}
                            name="file"
                            children={fileuploadDesign}
                            // types={fileTypes}
                        />
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <div></div>
                        <div
                            style={{
                                display: "grid",
                                gap: "0.4rem",
                                gridTemplateColumns: "1fr 1fr",
                                justifyItems: "left",
                                width: "70%",
                            }}>
                            {banners?.map((item) => (
                                <div
                                    className={
                                        dashboardclasses[
                                            "subcategory-img-wrapper"
                                        ]
                                    }>
                                    <button
                                        type="button"
                                        name={item.name}
                                        id={item.id}
                                        btnType={"subcategoryimages"}
                                        onClick={deleteHandler}>
                                        <AiOutlineClose />
                                    </button>
                                    <img
                                        src={item.base64}
                                        alt=""
                                        width={"120px"}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="category">Offer Banners</label>

                        <FileUploader
                            classes={dashboardclasses["upload-image"]}
                            multiple={true}
                            handleChange={handleChange2}
                            name="file"
                            children={fileuploadDesign}
                            // types={fileTypes}
                        />
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <div></div>
                        <div
                            style={{
                                display: "grid",
                                gap: "0.4rem",
                                gridTemplateColumns: "1fr 1fr",
                                justifyItems: "left",
                                width: "70%",
                            }}>
                            {OfferBanners?.map((item) => (
                                <div
                                    className={
                                        dashboardclasses[
                                            "subcategory-img-wrapper"
                                        ]
                                    }>
                                    <button
                                        type="button"
                                        id={item.id}
                                        name={item.name}
                                        btnType={"offerbanners"}
                                        onClick={deleteHandler}>
                                        <AiOutlineClose />
                                    </button>
                                    <img
                                        src={item.base64}
                                        alt=""
                                        width={"120px"}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="">Priority</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="number"
                                {...register("priority", {
                                    required: "priority is required",
                                    validate: validateNegativeValues,
                                })}
                            />
                            {errors?.priority && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.priority?.message}
                                </p>
                            )}
                        </div>
                    </div>

                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="status">Status</label>
                        <div className={dashboardclasses["select"]}>
                            <select
                                {...register("status", {
                                    required: "status is required",
                                })}>
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                            </select>
                            {errors?.status && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.status?.message}
                                </p>
                            )}
                        </div>
                    </div>

                    <div className={dashboardclasses["add-btn"]}>
                        <button type="button" onClick={CancelHandler}>
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className={dashboardclasses["add-category-btn"]}>
                            {props.editable ? "update" : "Add Subcategory"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default AddCategory;
